module.exports = __webpack_public_path__ + "wave-4.jXF6B2Xf.svg";